var _path, _path2, _path3, _path4, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScanQrBtnOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1H5C3.89543 1 3 1.89543 3 3V6",
    stroke: "#ff721f",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 1H16C17.1046 1 18 1.89543 18 3V6",
    stroke: "#ff721f",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16H5C3.89543 16 3 15.1046 3 14V11",
    stroke: "#ff721f",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 16H16C17.1046 16 18 15.1046 18 14V11",
    stroke: "#ff721f",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.75,
    y1: 8.25,
    x2: 20.25,
    y2: 8.25,
    stroke: "#ff721f",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanQrBtnOrange);
export default __webpack_public_path__ + "static/media/scanQrBtnOrange.d04717496ce867e60907d58211a3b80e.svg";
export { ForwardRef as ReactComponent };